{
  "apply_access": "Применить правила",
  "badge_calculated": "Расчётное",
  "badge_hidden": "Скрыто",
  "badge_mandatory": "Обязательное",
  "badge_system": "Системное",
  "change_field_name": "Поле с таким именем уже существует, попробуйте изменить название поля",
  "change_table_name": "Таблица с таким именем уже существует, попробуйте изменить название таблицы",
  "choose_field_type": "Выберите тип поля",
  "confirmation_delete_field": "Вы хотите удалить этот поле?",
  "confirmation_delete_section": "Вы хотите удалить этот раздел?",
  "confirmation_delete_table": "Вы хотите удалить эту таблицу?",
  "create_fields_for_table": "Создайте поля для этой таблицы",
  "create_new_custom_table": "Создать настраиваемую таблицу",
  "create_new_field": "Создать настраиваемое поле",
  "create_new_field_type": "Создать новое поле",
  "create_new_section": "Сгруппируйте поля по заголовкам",
  "create_new_table": "Создать новую настраиваемую таблицу",
  "create_options": "Создать варианты",
  "currency_description": "Для зарплат, бюджетов и платежей",
  "custom_fields": "Настраиваемые поля",
  "custom_table": "Настраиваемая таблица",
  "custom_table_settings": "Настройки настраиваемой таблицы",
  "system_table_settings": "Настройки системной таблицы",
  "system_field_title_fallback": "Если заголовок не заполнен, будет использовано системное название поля.",
  "system_field_title_reset_hint": "Вы можете восстановить локализованное системное название поля.",
  "custom_tables": "Настраиваемые таблицы",
  "date_description": "Выберите дату в календаре",
  "datetime_description": "Выберите дату и время в календаре",
  "default_value": "Значение по умолчанию",
  "edit_field_type": "Редактировать поле",
  "edit_option": "Редактировать вариант",
  "edit_section": "Редактировать секцию",
  "edit_table": "Редактировать таблицу",
  "email_description": "Укажите адрес электронной почты",
  "employee_reference_description": "Выберите коллегу из справочника",
  "employee_reference_title": "Ссылка на сотрудника",
  "entity_reference_description": "Выберите значение из справочника",
  "entity_reference_title": "Ссылка на справочник",
  "employee_tab_sidebar_title": "Общая информация",
  "export_with_history": "Экспорт с историей",
  "field": "Поле",
  "field_be_visible": "видно",
  "field_deleted": "Поле удалено",
  "field_type": "Тип поля",
  "fields": "Поля",
  "fields_how_works": "Выберите, что будет отображаться в каждом профиле",
  "file_description": "Любые файлы из системы",
  "for_all_employees": "Для всех сотрудников",
  "hint": "Подсказка",
  "historical_description": "Эта таблица используется для отслеживания изменений с течением времени.",
  "historical_title": "Историческая таблица",
  "disable_historical_confirmation_title": "Отключить историческую таблицу?",
  "disable_historical_confirmation_description": "Даты строк сохранятся. Колонка даты и её настройки снова появятся, если позже включить историю.",
  "image_description": "Файлы изображений из системы",
  "information_about_permissions": "{this_entity} не будет {entity_be_visible} никому, пока вы не настроите в разрешениях ролей",
  "just_reminder": "Просто напоминание",
  "lets_choose": "Приступим к натсройкам",
  "long_text_description": "Для заметок, описаний и других длинных текстов",
  "long_text_title": "Длинный текст",
  "make_mandatory": "Сделать это поле обязательным при добавлении или обновлении профилей",
  "manage_roles": "Управлять в настройках рабочего пространства",
  "mandatory": "Обязательное",
  "multiple": "Множественный выбор",
  "multiple_description": "Можно выбрать несколько вариантов ответа",
  "multiple_employees_description": "Можно выбрать нескольких сотрудников",
  "multiple_references_description": "Можно выбрать несколько значений справочника",
  "need_help_question": "Нужна помощь с дальнейшей настройкой?",
  "new_custom_table": "Новая настраиваемая таблица",
  "new_field": "Новое поле",
  "new_field_created": "Новое поле создано",
  "new_field_is_hidden": "Это новое поле сейчас скрыто",
  "new_field_is_hidden_information": "Никто, включая вас, не сможет видеть или использовать его, пока доступ не будет предоставлен в разрешениях ролей. У вас нет прав, чтобы сделать его видимым или редактируемым",
  "new_field_ready": "Отлично! Новое поле создано!",
  "new_section": "Новый раздел",
  "number_description": "Целые числа или десятичные дроби",
  "number_title": "Число",
  "ok_got_it": "Хорошо",
  "open_role_permissions": "Открыть настройки ролей",
  "reference_archived": "Архивный",
  "reference_directory": "Справочник",
  "link_to_employment_legal_entity": "Связать с юрлицом занятости",
  "link_to_employment_legal_entity_hint": "Значение берётся из трудовых данных. Право на правку колонки позволяет менять юрлицо сотрудника",
  "link_to_position_department": "Связать с департаментом должности",
  "link_to_position_department_hint": "Значение берётся из данных о должности. Право на правку колонки позволяет менять департамент сотрудника",
  "link_to_position_division": "Связать с дивизионом должности",
  "link_to_position_division_hint": "Значение берётся из данных о должности. Право на правку колонки позволяет менять дивизион сотрудника",
  "link_to_position_location": "Связать с локацией должности",
  "link_to_position_location_hint": "Значение берётся из данных о должности. Право на правку колонки позволяет менять локацию сотрудника",
  "options_required_for_select": "Необходимо добавить хотя бы один вариант для этого типа поля",
  "percentage_description": "Числа от 0 до 100",
  "percentage_title": "Проценты",
  "phone_description": "Укажите мобильный телефон",
  "section_deleted": "Раздел удалён",
  "sections": "Разделы",
  "set_access": "Назначьте доступ для каждой роли в вашем рабочем пространстве:",
  "set_default_apply_to_all": "Применить это значение ко всем новым и существующим профилям сотрудников по умолчанию",
  "set_default_apply_to_new": "Применить это значение ко всем новым профилям сотрудников по умолчанию",
  "set_default_value": "Установить значение по умолчанию",
  "settings_title": "Профиль сотрудника",
  "setup_field_permissions": "Настройка прав доступа к полю",
  "single_select_description": "Выберите один вариант из списка",
  "switch_description": "Вы сможете упарвлять включение/отключением",
  "switch_title": "Переключатель",
  "system_table": "Системная таблица",
  "table_be_visible": "видна",
  "table_deleted": "Таблица удалена",
  "text_description": "Однострочное текстовое поле для простого ввода",
  "this_field": "Это поле",
  "this_table": "Эта таблица",
  "unavailable_for_this_page": "Недоступно для этой страницы",
  "url_description": "Укажите ссылку",
  "value_text": "Значение",
  "visibility": "Показывать",
  "visibility_always": "Всегда",
  "visibility_never": "Никогда",
  "visibility_when_filled": "Показывать если заполнено",
  "view_all_data": "Посмотреть все данные",
  "who_can_configure": "Эти коллеги могут настраивать доступ:",
  "who_should_see": "Кто должен видеть это поле?",
  "hired_via_job": "Нанят из подбора",
  "~": "~",
  "placeholder": "Плейсхолдер",
  "recruiting_settings_title": "Поля подбора",
  "recruiting_settings_description": "Настройка полей кандидатов, вакансий и офферов",
  "applicant_fields": "Поля кандидата",
  "applicant_fields_description": "Настройка полей анкеты кандидата",
  "recruiting_fields_how_works": "Настройте порядок, названия, подсказки, видимость и обязательность полей",
  "job_fields": "Поля вакансии",
  "job_fields_description": "Настройка полей вакансии",
  "offer_fields": "Поля оффера",
  "offer_fields_description": "Настройка полей оффера",
  "job_hiring_process": "Процесс найма",
  "visible_to_candidate": "Видно кандидату",
  "visible_to_candidate_description": "Показывать поле на публичной странице оффера и в PDF",
  "make_mandatory_job": "Сделать это поле обязательным для вакансий в статусах «Активная» и «На паузе». Черновик и архив можно сохранить без него",
  "make_mandatory_offer": "Сделать это поле обязательным при создании или редактировании оффера",
  "job_description_hidden_ai_title": "AI-оценка кандидатов будет недоступна",
  "job_description_hidden_ai_description": "Без описания в форме вакансии не будет блока AI: требования генерируются из описания"
}
